import * as React from 'react';
import classNames from 'classnames';
import './menu.module.scss';
import { observer } from 'mobx-react';
import { EnhancedLocationDescriptor } from '../../../mainv3/routes';
import { routingStore } from '../../../common/stores/routing';
import { AccountRoutes } from '../../routes/AccountRoutes';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';

type MenuItemProps = {
    id?: string;
    activePattern: string;
    to?: EnhancedLocationDescriptor;
    href?: string;
    children: any;
};

const MenuItem = observer(({ activePattern, to, href, children, id }: MenuItemProps) => {
    const active = routingStore.location.pathname.includes(activePattern);
    if (href) {
        return (
            <a styleName={classNames('menu-item', { active: active })} href={href} id={id}>
                <span styleName="menu-item-text">{children}</span>
            </a>
        );
    }
    return (
        <div styleName={classNames('menu-item', { active: active })} onClick={() => routingStore.push(to)} id={id}>
            <span styleName="menu-item-text">{children}</span>
        </div>
    );
});

export const Menu = observer(() => {
    return (
        <div styleName="menu" id="menu">
            {GlobalStatesV3.viewport.isNonSp && (
                <div styleName="header-wrapper">
                    <div styleName="header">
                        <div styleName="title">MYPAGE</div>
                        <div styleName="sub-title">マイページ</div>
                    </div>
                </div>
            )}
            <MenuItem id="menu-item-profile" activePattern={'profile'} to={AccountRoutes.profile()}>
                プロフィールを編集
            </MenuItem>
            <MenuItem id="menu-item-reservations" activePattern={'reservations'} to={AccountRoutes.reservations()}>
                予約の確認
            </MenuItem>
            <MenuItem id="menu-item-plans" activePattern={'plans'} to={AccountRoutes.plan()}>
                プランの確認 / 変更
            </MenuItem>
            <MenuItem id="menu-item-home-location" activePattern={'home_location'} to={AccountRoutes.homeLocation()}>
                ホーム拠点の確認/変更
            </MenuItem>
            <MenuItem id="menu-item-payments" activePattern={'payments'} to={AccountRoutes.payments()}>
                お支払い情報 / 変更
            </MenuItem>
            <MenuItem id="menu-item-password" activePattern={'password'} to={AccountRoutes.password()}>
                パスワードを変更
            </MenuItem>
            <MenuItem id="menu-item-email" activePattern={'email'} to={AccountRoutes.email()}>
                メールの設定
            </MenuItem>
            <MenuItem id="menu-item-sign-out" activePattern={'sign_out'} to={AccountRoutes.signOut()}>
                ログアウト
            </MenuItem>
        </div>
    );
});
